<template>
  <div class="agent-page">
        <div style="display: flex;  justify-content: space-between;">
            <h2 class="page-title">招标文件下载记录</h2>
            <el-button type="primary" icon="el-icon-back" size="small" @click="handleBack">
              返回
            </el-button>
        </div>

        <!-- 列表 -->
        <el-table :data="listAll" border stripe class="download-table">
          <el-table-column type="index" width="70" label="NO."></el-table-column>
          <el-table-column prop="fileName" label="文件名称" min-width="220" show-overflow-tooltip></el-table-column>
          <el-table-column prop="fileCode" label="文件编码" min-width="160" show-overflow-tooltip></el-table-column>
          <el-table-column prop="sectionName" label="标段名称" min-width="160" show-overflow-tooltip></el-table-column>
          <el-table-column prop="bidderName" label="投标人名称" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="downloadCount" label="下载次数" width="120"></el-table-column>
        </el-table>
        <div class="pagination-bar">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="listAll.length"
            :page-size="pageSize"
            :current-page.sync="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
  
  </div>
</template>

<script>
export default {
  name: 'UploadBidFile',
  data() {
    return {
      form: {
        fileName: '',
        fileCode: '',
        sectionName: '',
        bidderName: ''
      },
      listAll: [
        {
          fileName: '中山大厦项目-招标文件V1.pdf',
          fileCode: 'ZB-2025-001',
          sectionName: '一标段',
          bidderName: '华夏建设有限公司',
          downloadCount: 5
        },
        {
          fileName: '中山大厦项目-答疑澄清1.pdf',
          fileCode: 'ZB-2025-001-QA1',
          sectionName: '一标段',
          bidderName: '盛世工程集团111',
          downloadCount: 2
        }
      ],
      list: [],
      currentPage: 1,
      pageSize: 10
    }
  },
  methods: {
    //返回上一页
    handleBack() {
      console.log('------执行返回上一页------')
      this.$router.go(-1)
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
    },
    handleCurrentChange(val) {
      this.currentPage = val
    }
  }
  
  

}
</script>

<style lang="less" scoped>
@import '@/assets/css/agent-common.css';
 .download-table {
  margin-top: 20px;
   background: #fff;
 }
  .pagination-bar {
    margin: 14px 0 0;
    text-align: right;
  }
</style>